// document.addEventListener("DOMContentLoaded", function () {
//   // Configuration
//   const config = {
//     dropdownSelector: ".rc_widget__option__plans__dropdown",
//     containerSelector: ".rc-selling-plans.rc_widget__option__plans",
//     messages: [
//       "✓ FREE Shipping on Subscriptions",
//       "✓ Modify or Cancel Anytime",
//     ],
//     maxWaitTime: 8000, // 8 seconds max wait
//     checkInterval: 200, // Check every 200ms
//   };

//   // Function to add checkmark to dropdown
//   function addCheckmarkToDropdown(dropdown) {
//     // Store original options text
//     Array.from(dropdown.options).forEach((opt) => {
//       if (!opt.dataset.originalText) {
//         opt.dataset.originalText = opt.textContent;
//       }
//     });

//     // Update selected option
//     const updateSelected = () => {
//       const selected = dropdown.options[dropdown.selectedIndex];
//       dropdown.options.forEach((opt) => {
//         opt.textContent = opt.dataset.originalText;
//       });
//       selected.textContent = `✓ ${selected.dataset.originalText}`;
//     };

//     // Initial update
//     updateSelected();

//     // Update on change
//     dropdown.addEventListener("change", updateSelected);
//   }

//   // Function to add promotional messages
//   function addPromoMessages(container) {
//     // Create messages container
//     const messagesDiv = document.createElement("div");
//     messagesDiv.classList.add("custom-messages");
//     messagesDiv.style.marginLeft = "35px";

//     // Add first message
//     const shippingMsg = document.createElement("p");
//     shippingMsg.textContent = config.messages[0];
//     shippingMsg.style.margin = "8px 0 0 0";
//     shippingMsg.style.fontSize = "13px";
//     shippingMsg.style.color = "rgba(38, 38, 38, 0.8)";
//     messagesDiv.appendChild(shippingMsg);

//     // Add second message
//     const cancelMsg = document.createElement("p");
//     cancelMsg.textContent = config.messages[1];
//     cancelMsg.style.margin = "4px 0 0 0";
//     cancelMsg.style.fontSize = "13px";
//     cancelMsg.style.color = "rgba(38, 38, 38, 0.8)";
//     messagesDiv.appendChild(cancelMsg);

//     // Insert after container
//     container.parentNode.insertBefore(messagesDiv, container.nextSibling);
//   }

//   // Main observer function
//   function observeElements() {
//     const startTime = Date.now();
//     let dropdownFound = false;
//     let containerFound = false;

//     const checkElements = () => {
//       // Check dropdown
//       if (!dropdownFound) {
//         const dropdown = document.querySelector(config.dropdownSelector);
//         if (dropdown) {
//           addCheckmarkToDropdown(dropdown);
//           dropdownFound = true;
//         }
//       }

//       // Check container
//       if (!containerFound) {
//         const container = document.querySelector(config.containerSelector);
//         if (container) {
//           addPromoMessages(container);
//           containerFound = true;
//         }
//       }

//       // Stop if both found or timeout
//       return dropdownFound && containerFound;
//     };

//     // MutationObserver
//     const observer = new MutationObserver(() => {
//       if (checkElements() || Date.now() - startTime > config.maxWaitTime) {
//         observer.disconnect();
//       }
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//     });

//     // Interval fallback
//     const interval = setInterval(() => {
//       if (checkElements() || Date.now() - startTime > config.maxWaitTime) {
//         clearInterval(interval);
//         observer.disconnect();
//       }
//     }, config.checkInterval);
//   }

//   // Start observing
//   observeElements();
// });

// document.addEventListener("DOMContentLoaded", function () {
//   // Configuration
//   const config = {
//     priceSelector:
//       ".rc-option__price.rc_widget__price.rc_widget__price--subsave",
//     labelText: "Best Deal",
//     maxWaitTime: 8000, // 8 seconds max wait
//     checkInterval: 200, // Check every 200ms
//   };

//   // Function to add the "Best Deal" label INSIDE the price element
//   function addBestDealLabel(priceElement) {
//     // Create the label span (using span instead of div for inline display)
//     const labelSpan = document.createElement("span");
//     labelSpan.className = "price-after";
//     labelSpan.textContent = config.labelText;

//     // Style the label (adjust as needed)
//     labelSpan.style.display = "inline-block";

//     // Append INSIDE the price element
//     priceElement.appendChild(labelSpan);
//   }

//   // Main observer function
//   function observePriceElement() {
//     const startTime = Date.now();

//     const observer = new MutationObserver((mutations, obs) => {
//       const priceElement = document.querySelector(config.priceSelector);
//       if (priceElement && !priceElement.querySelector(".price-after")) {
//         addBestDealLabel(priceElement);
//         obs.disconnect();
//       } else if (Date.now() - startTime > config.maxWaitTime) {
//         obs.disconnect();
//       }
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//     });

//     // Fallback interval check
//     const interval = setInterval(() => {
//       const priceElement = document.querySelector(config.priceSelector);
//       if (priceElement && !priceElement.querySelector(".price-after")) {
//         addBestDealLabel(priceElement);
//         clearInterval(interval);
//         observer.disconnect();
//       } else if (Date.now() - startTime > config.maxWaitTime) {
//         clearInterval(interval);
//         observer.disconnect();
//       }
//     }, config.checkInterval);
//   }

//   // Start observing
//   observePriceElement();
// });


document.addEventListener("DOMContentLoaded", function () {
  // Configuration
  const config = {
    dropdownSelector: ".rc_widget__option__plans__dropdown",
    containerSelector: ".rc-selling-plans.rc_widget__option__plans",
    messagesContainerClass: "custom-messages",
    bestDealClass: "best-deal",
    bestDealTargetSelector: ".rc-template__legacy-radio .rc-radio.rc-option__subsave",
    messages: [
      "✓ FREE Shipping on Subscriptions",
      "✓ Modify or Cancel Anytime",
    ],
    maxWaitTime: 8000,
    checkInterval: 200,
  };

  // Function to add checkmark to dropdown
  function addCheckmarkToDropdown(dropdown) {
    // Store original options text
    Array.from(dropdown.options).forEach((opt) => {
      if (!opt.dataset.originalText) {
        opt.dataset.originalText = opt.textContent;
      }
    });

    // Function to apply transform
    const applyTransform = () => {
      const container = document.querySelector(config.containerSelector);
      const messagesDiv = document.querySelector(`.${config.messagesContainerClass}`);
      
      if (container && messagesDiv) {
        container.style.transform = "translateY(-10px)";
        messagesDiv.style.transform = "translateY(-10px)";
      }
    };

    // Update selected option
    const updateSelected = () => {
      const selected = dropdown.options[dropdown.selectedIndex];
      dropdown.options.forEach((opt) => {
        opt.textContent = opt.dataset.originalText;
      });
      selected.textContent = `✓ ${selected.dataset.originalText}`;
      
      // Apply transform when any option is selected
      applyTransform();
    };

    // Initial update
    updateSelected();

    // Update on change (when an option is clicked/selected)
    dropdown.addEventListener('change', updateSelected);
  }

  // Function to add promotional messages
  function addPromoMessages(container) {
    // Create messages container
    const messagesDiv = document.createElement("div");
    messagesDiv.classList.add(config.messagesContainerClass);
    messagesDiv.style.marginLeft = "35px";

    // Add first message
    const shippingMsg = document.createElement("p");
    shippingMsg.textContent = config.messages[0];
    shippingMsg.style.margin = "8px 0 0 0";
    shippingMsg.style.fontSize = "13px";
    shippingMsg.style.color = "rgba(38, 38, 38, 0.8)";
    messagesDiv.appendChild(shippingMsg);

    // Add second message
    const cancelMsg = document.createElement("p");
    cancelMsg.textContent = config.messages[1];
    cancelMsg.style.margin = "4px 0 0 0";
    cancelMsg.style.fontSize = "13px";
    cancelMsg.style.color = "rgba(38, 38, 38, 0.8)";
    messagesDiv.appendChild(cancelMsg);

    // Insert after container
    container.parentNode.insertBefore(messagesDiv, container.nextSibling);
  }

  // Function to add "Best Deal" badge
  function addBestDealBadge() {
    const targetElement = document.querySelector(config.bestDealTargetSelector);
    if (targetElement) {
      // Check if badge already exists
      if (targetElement.querySelector(`.${config.bestDealClass}`)) return;
      
      // Create the badge
      const bestDealSpan = document.createElement("span");
      bestDealSpan.classList.add(config.bestDealClass);
      bestDealSpan.textContent = "Best Deal";
      
      // Style the badge
      bestDealSpan.style.position = "absolute";
      bestDealSpan.style.right = "10px";
      bestDealSpan.style.top = "40px";
      bestDealSpan.style.backgroundColor = "#EB763E"; // Gold color
      bestDealSpan.style.color = "#FFF";
      bestDealSpan.style.padding = "3px 12px";
      bestDealSpan.style.borderRadius = "4px";
      bestDealSpan.style.fontSize = "12px";
      bestDealSpan.style.margin = "0";
      
      // Make sure target has position relative
      targetElement.style.position = "relative";
      
      // Append the badge
      targetElement.appendChild(bestDealSpan);
    }
  }

  // Main observer function
  function observeElements() {
    const startTime = Date.now();
    let dropdownFound = false;
    let containerFound = false;
    let bestDealAdded = false;

    const checkElements = () => {
      // Check dropdown
      if (!dropdownFound) {
        const dropdown = document.querySelector(config.dropdownSelector);
        if (dropdown) {
          addCheckmarkToDropdown(dropdown);
          dropdownFound = true;
        }
      }

      // Check container
      if (!containerFound) {
        const container = document.querySelector(config.containerSelector);
        if (container) {
          addPromoMessages(container);
          containerFound = true;
        }
      }

      // Check best deal target
      if (!bestDealAdded) {
        addBestDealBadge();
        bestDealAdded = document.querySelector(`${config.bestDealTargetSelector} .${config.bestDealClass}`) !== null;
      }

      // Stop if all found or timeout
      return dropdownFound && containerFound && bestDealAdded;
    };

    // MutationObserver
    const observer = new MutationObserver(() => {
      if (checkElements() || Date.now() - startTime > config.maxWaitTime) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Interval fallback
    const interval = setInterval(() => {
      if (checkElements() || Date.now() - startTime > config.maxWaitTime) {
        clearInterval(interval);
        observer.disconnect();
      }
    }, config.checkInterval);
  }

  // Start observing
  observeElements();
});